"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.QUERY_SEARCH_PARAMS_WHITELIST = exports.REFERRING_DOMAIN_COOKIE_KEY = exports.SEARCH_PARAMS_COOKIE_KEY = void 0;
var SEARCH_PARAMS_COOKIE_KEY = 'we_search_params';
exports.SEARCH_PARAMS_COOKIE_KEY = SEARCH_PARAMS_COOKIE_KEY;
var REFERRING_DOMAIN_COOKIE_KEY = 'we_referring_domain';
exports.REFERRING_DOMAIN_COOKIE_KEY = REFERRING_DOMAIN_COOKIE_KEY;
var QUERY_SEARCH_PARAMS_WHITELIST = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'campaign_sfid', 'owner_sfid', 'dclid', 'gclid', 'gclsrc'];
exports.QUERY_SEARCH_PARAMS_WHITELIST = QUERY_SEARCH_PARAMS_WHITELIST;